/**
 * Monica: All-In-One AI Assistant
 *
 * Stamps its own id and version onto <body>, which makes it both identifiable and
 * *version*-identifiable — a finer-grained fingerprint than most extensions give up.
 * Observed on version 9.0.18.
 */
import { probeAttributePrefix, probeSelector } from '../core/probe';
import type { ExtensionDefinition } from '../core/types';
const ID = 'ofpnmcalabcbjgholdjcjblkibolbppb';
export const monica: ExtensionDefinition = {
  id: ID,
  name: 'Monica: All-In-One AI Assistant',
  storeUrl: `https://chromewebstore.google.com/detail/${ID}`,
  users: 3_000_000,
  notes:
    'body[monica-version] leaks the exact installed version, narrowing the fingerprint ' +
    'further than a yes/no answer would.',
  signals: [
    { id: 'dom-body-monica-attrs', kind: 'dom',
      description: 'Check <body monica-id> / <body monica-version> — installation markers that also disclose the version.',
      weight: 1, run: () => probeAttributePrefix('monica-') },
    { id: 'dom-widget-root', kind: 'dom',
      description: 'Look for #monica-content-root or #monica-writing-entry-btn-root, the injected widget containers.',
      weight: 1, run: () => probeSelector('#monica-content-root, [id^="monica-"]', { timeoutMs: 1500 }) },
  ],
};
